import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as PostalCodes from 'postal-codes-js';
import { fireStatusUpdate, StatusTypes, Component, Namespace, UserAddressCommandNames } from '@chegg/commerce-utils';
import { getAddress } from '../../api';
import { getCities } from './UserAddressState.actions';
import { updatedCountry, updatedZipcode, selectedCity, resetCitiesData, getAddressSuggestionsSuccess, getAddressSuggestionsFailure } from './UserAddressState.slice';
import { handleAddressValidationError, handleInvalidZipcodeError, sendErrorCallbacksToHost, Timer } from './UserAddressState.helpers';
import { isZipMandatory, invalidZipcode } from '../../utils/ZipUtil';
export var getCitiesListener = {
  actionCreator: getCities,
  effect: function () {
    var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, listenerApi) {
      var _response$errors, _response$data;
      var countryFocused, allowInvalidZipcodes, regexValidation, _listenerApi$getState, _listenerApi$getState2, value, focused, countryCode, zipValidation, timerObj, response, valueCurrent;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            countryFocused = action.payload.countryFocused;
            allowInvalidZipcodes = listenerApi.getState().config.debug.allowInvalidZipcodes; // fetch regexValidation from config if we need optional zipcodes
            // const { regexValidation } = config;
            regexValidation = true;
            _listenerApi$getState = listenerApi.getState().userAddress, _listenerApi$getState2 = _listenerApi$getState.zip, value = _listenerApi$getState2.value, focused = _listenerApi$getState2.focused, countryCode = _listenerApi$getState.country.countryCode; // if debugging, don't fetch city/state information and skip zip validation
            if (!allowInvalidZipcodes) {
              _context.next = 7;
              break;
            }
            listenerApi.dispatch(updatedZipcode({
              error: '',
              invalid: ''
            }));
            return _context.abrupt("return");
          case 7:
            if (!(!value || !countryCode)) {
              _context.next = 10;
              break;
            }
            listenerApi.dispatch(resetCitiesData());
            return _context.abrupt("return");
          case 10:
            if (!invalidZipcode(value, countryCode)) {
              _context.next = 14;
              break;
            }
            // resetCitiesData set address validation response to initial State
            listenerApi.dispatch(resetCitiesData());
            handleInvalidZipcodeError(listenerApi.dispatch);
            return _context.abrupt("return");
          case 14:
            // NPM package postal-codes does not validate UM equivalent to US
            // see: https://en.wikipedia.org/wiki/List_of_postal_codes
            zipValidation = countryCode === 'UM' ? PostalCodes.validate('US', value) : PostalCodes.validate(countryCode, value);
            if (!(zipValidation !== true)) {
              _context.next = 19;
              break;
            }
            // resetCitiesData set address validation response to initial State
            listenerApi.dispatch(resetCitiesData());

            // invalid error onBlur for mandatory no matter what regexValidation config is
            // show error onBlur if regexValidation true for optional
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!focused && (isZipMandatory(countryCode) || regexValidation)) {
              handleInvalidZipcodeError(listenerApi.dispatch);
            }
            return _context.abrupt("return");
          case 19:
            if (focused || countryFocused) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return");
          case 21:
            timerObj = new Timer(listenerApi.dispatch);
            response = {
              errors: null,
              data: null
            }; // fetch city/state data if value does not have leading or trailing whitespace
            if (!(value.trim().length == value.length)) {
              _context.next = 28;
              break;
            }
            // show the progress indicator
            timerObj.showProgress('start', response, value);
            _context.next = 27;
            return getAddress({
              zipcode: value,
              country: countryCode
            });
          case 27:
            response = _context.sent;
          case 28:
            if (!((_response$errors = response.errors) !== null && _response$errors !== void 0 && _response$errors.length)) {
              _context.next = 32;
              break;
            }
            _context.next = 31;
            return timerObj.showProgress('timer', response, value);
          case 31:
            sendErrorCallbacksToHost(response.errors);
          case 32:
            // Address validation reponse error
            if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.error) {
              // special case where additional chars were entered while data is being fetched (dancing dots).
              // when the dancing dots were gone, the inline error also disappears.
              // must keep the inline error.
              // compare the string that triggers the data fetching and the current string.
              // if different, don't do the getAddressSuggestionsFailure and handleAddressValidationError.
              valueCurrent = listenerApi.getState().userAddress.zip.value;
              if (value === valueCurrent) {
                listenerApi.dispatch(getAddressSuggestionsFailure(response.data));
                handleAddressValidationError({
                  error: response.data.error,
                  value: value,
                  countryCode: countryCode,
                  dispatch: listenerApi.dispatch
                });
              }
            }
            // Address Validation response success
            else if (response.data) {
              listenerApi.dispatch(updatedZipcode({
                error: '',
                invalid: ''
              }));
              listenerApi.dispatch(getAddressSuggestionsSuccess(response.data));
              // hide the progress indicator
              timerObj.showProgress('stop', response, value);
            }
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function effect(_x, _x2) {
      return _effect.apply(this, arguments);
    }
    return effect;
  }()
};
export var updatedCountryListener = {
  actionCreator: updatedCountry,
  effect: function effect(_, listenerApi) {
    var userAddressState = listenerApi.getState().userAddress;
    var zip = userAddressState.zip,
      country = userAddressState.country,
      selectedCity = userAddressState.selectedCity;
    var error = country.error;
    if (!error) {
      fireStatusUpdate([{
        status: StatusTypes.SUCCESS,
        command: UserAddressCommandNames.ADDRESS_UPDATE,
        payload: {
          component: Component.COUNTRY_SELECTED,
          data: {
            zip: zip,
            country: country,
            selectedCity: selectedCity
          }
        }
      }], Namespace.USER_ADDRESS);
    }
  }
};
export var updatedZipcodeListener = {
  actionCreator: updatedZipcode,
  effect: function effect(_, listenerApi) {
    var userAddressState = listenerApi.getState().userAddress;
    var zip = userAddressState.zip,
      country = userAddressState.country,
      selectedCity = userAddressState.selectedCity;
    var focused = zip.focused;
    if (!focused) {
      fireStatusUpdate([{
        status: StatusTypes.SUCCESS,
        command: UserAddressCommandNames.ADDRESS_UPDATE,
        payload: {
          component: Component.ZIPCODE,
          data: {
            zip: zip,
            country: country,
            selectedCity: selectedCity
          }
        }
      }], Namespace.USER_ADDRESS);
    }
  }
};
export var selectedCityListener = {
  actionCreator: selectedCity,
  effect: function effect(_, listenerApi) {
    var userAddressState = listenerApi.getState().userAddress;
    var zip = userAddressState.zip,
      country = userAddressState.country,
      selectedCity = userAddressState.selectedCity;
    fireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: UserAddressCommandNames.ADDRESS_UPDATE,
      payload: {
        component: Component.CITY_SELECTED,
        data: {
          zip: zip,
          country: country,
          selectedCity: selectedCity
        }
      }
    }], Namespace.USER_ADDRESS);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/UserAddressState/UserAddressState.listeners.js
// module id = 4426
// module chunks = 11